import React from 'react';
import { useAppOrigin } from '../hooks/useValidate';
import { Col } from 'react-bootstrap';
import { Homepage } from '../components/user/Homepage';
import { Menu } from '../components/shared/Menu';
import { useSelector } from 'react-redux';
import { Loading } from '../components/shared/Loading';
import { getTier } from '../helpers/menu';
import { useMenu } from '../hooks/useHelpMenu';
import { slimTier } from '../constants/form';
import AltHomepage from '../components/user/AltHomepage/AltHomepage';
import {useSwitchDesign} from '../hooks/useSwitchDesign';
import { useDispatch } from 'react-redux';
import { BASE_FETCH_DOCUMENTS, BASE_SET_FETCHED_DOCUMENTS } from '../redux/types/base';
import { isUndefinedNull } from '../helpers/shared';

/**
 * User home page and level menu page
 * @returns {JSX}
 */
const HomepagePage = () => {
  const { autoLoginURL } = useSelector(state => state.base);
  useAppOrigin();
  const [tiers] = React.useState(getTier() || [])
  const { onClick } = useMenu()
  
  React.useEffect(() => {
    const slimAdvanced = tiers?.find(tier => tier?.unique_name === slimTier)
    setTimeout(() => {
      if (slimAdvanced && autoLoginURL?.active) {
        onClick(slimAdvanced)
      }
    }, 0)
  }, [tiers])
  const { isNewDesign, switchBtn } = useSwitchDesign()

  const dispatch = useDispatch()
  // Resetting variable to be able to fetch documents again when the user accesses the tier
  React.useEffect(() => {
    dispatch({
      type: BASE_FETCH_DOCUMENTS,
      payload: false
    })
  }, [])

  React.useEffect(() => {
    dispatch({
      type: BASE_SET_FETCHED_DOCUMENTS,
      payload: []
    })
  }, [])


  return (
    <>
    	{ switchBtn }
      {
        (!isNewDesign || isUndefinedNull(isNewDesign)) ? (
          <>
            <Col className={`p-0 ${autoLoginURL?.active ? ' d-none' : ''} `} xs={12} md={6} xl={8}>
              <Homepage />
            </Col>
            <Col className={`p-0 ${autoLoginURL?.active ? ' d-none' : ''} `} xs={12} md={6} xl={4}>
              <Menu />
            </Col>
          </>
        ) : (
          <AltHomepage />
        )
      }
      { (autoLoginURL?.active) && <Loading />}
    </>
  );
};

export default HomepagePage;